import { isIOS, isMobile } from 'mobile-device-detect';

export type StreamPlayerKind = 'veplayer' | 'tcplayer' | 'canvas';

/*
 * Which stream backend plays a feed, for one rule shared by every game's video
 * (the cockfight pane and the Tài Xỉu pane) so they cannot drift apart. It is
 * the rule `pages/cock-fight.vue` has always used (`streamv` in the query):
 *
 *   streamv=3        VePlayer on every device (also the default: no / other value)
 *   streamv=1        TCPlayer on every device
 *   streamv=2        VePlayer + canvas; TCPlayer on iOS
 */
export const getStreamPlayerKind = (streamVersion: number | string): StreamPlayerKind => {
  const parsed = Number(streamVersion);
  const version = [1, 2, 3].includes(parsed) ? parsed : 3;
  const onIOS = isMobile && isIOS;
  if (version === 3) return 'veplayer';
  if (version === 1 || (onIOS && version === 2)) return 'tcplayer';
  return 'canvas';
};
